export class RecommendedTitle {
    cdnRoot: string;
    coc: string;
    imgSrc: string;
    isLoggedIn: boolean;
    showFlag = false;
    title = window.translation['recommended_videos'];

    constructor(isLoggedIn: boolean, cdnRoot: string, coeCookie: string, cocCookie: string) {
        this.cdnRoot = cdnRoot;
        this.coc = cocCookie.toLowerCase();
        this.isLoggedIn = isLoggedIn;

        if (coeCookie.toLowerCase() === 'ww' && !this.isLoggedIn) {
            this.updateFlag();
        }
    }

    updateFlag() {
        this.imgSrc = `${this.cdnRoot}/static/common/Images/Flags/${this.coc}.png`;
        this.showFlag = true;
        this.title = window.translation['recommended_videos_in'];
    }
}
